import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { EmailTemplatesGeneralHttpClient } from './general-http-client';
import { EmailTemplatesGeneralActions } from './general.store';

@Injectable({ providedIn: 'root' })
export class EmailTemplatesGeneralEffects {
  public effects = createEffectFactory(EmailTemplatesGeneralActions, this.actions$);

  public fetchCollection$ = this.effects(EmailTemplatesGeneralActions.fetchCollection, () =>
    this.emailTemplatesGeneralHttpClient.loadCollection().pipe(map(data => ({ data }))),
  );

  public saveTemplate$ = this.effects(
    EmailTemplatesGeneralActions.createOnePessimistic,
    ({ payload: { data } }) =>
      this.emailTemplatesGeneralHttpClient
        .create(data)
        .pipe(map(data => ({ data: data.emailTemplate }))),
  );

  public deleteTemplate$ = this.effects(
    EmailTemplatesGeneralActions.removeOnePessimistic,
    ({ payload: { data } }) =>
      this.emailTemplatesGeneralHttpClient
        .delete(data)
        .pipe(map(data => ({ data: data.emailTemplate }))),
  );

  public updateTemplate$ = this.effects(
    EmailTemplatesGeneralActions.updateOnePessimistic,
    ({ payload: { data } }) =>
      this.emailTemplatesGeneralHttpClient
        .update(data)
        .pipe(map(data => ({ data: data.emailTemplate }))),
  );

  public updatePositions$ = this.effects(
    EmailTemplatesGeneralActions.updatePositions,
    ({ payload }) =>
      this.emailTemplatesGeneralHttpClient.updatePositions(payload).pipe(
        map(template =>
          EmailTemplatesGeneralActions.updatePositionsSuccess({ payload: { data: template } }),
        ),
        catchError(error =>
          of(EmailTemplatesGeneralActions.updatePositionsFailed({ payload: error })),
        ),
      ),
  );

  public duplicateTemplate$ = this.effects(
    EmailTemplatesGeneralActions.duplicateTemplate,
    ({ payload }) =>
      this.emailTemplatesGeneralHttpClient.duplicate(payload).pipe(
        map(template =>
          EmailTemplatesGeneralActions.duplicateTemplateSuccess({
            payload: { data: template, correlationId: payload.correlationId },
          }),
        ),
        catchError(error =>
          of(EmailTemplatesGeneralActions.duplicateTemplateFailed({ payload: error })),
        ),
      ),
  );

  constructor(
    private emailTemplatesGeneralHttpClient: EmailTemplatesGeneralHttpClient,
    private actions$: Actions,
  ) {}
}
